// extracted by mini-css-extract-plugin
export default {"wrapper":"Er-z","response":"Fr-z","error":"Gr-z","disabled":"Hr-z","buttons":"Ir-z","feedbackQuestionSection":"Jr-z","yesNoWrapper":"Kr-z"};